import {StringUtils} from "./StringUtils";

function highlight(unsafe : string)
{
    if (unsafe === null || unsafe === undefined) {
        return "";
    }

    return StringUtils.escapeHtml(unsafe)
        .replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, "<span class='highlight-email'>$&</span>")
}

export const Highlighter = () => {
    return
}

Highlighter.highlight = highlight;